<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Business Deals</div>
        <div>
          <bread-crumb :bread-crumbs="['Business Deals']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-row justify="space-between">
          <v-col cols="6" lg="4" xs="12">
            <v-btn depressed 
              color="primary text-capitalize"
              class="mr-2 action-btn"
              title="New Deal"
              @click="newDealClick()"
              small
            >
              New Deal
              <!-- <v-icon>mdi-plus</v-icon> -->
            </v-btn>
            <v-btn depressed  @click="downloadExcelsheet" color="primary" small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
          </v-col>
          <v-col cols="6" lg="4" xs="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              dense
              single-line
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table fixed-header  height="55vh"
        :headers="headers"
        :items="userList"
        :single-expand="true"
        :expanded.sync="expanded"
        item-key="deal_id"
        show-expand
        :search="search"
        class="py-4"
        dense
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-row justify="space-between" class="ma-5">
              <v-col cols="12" lg="9" xs="12">
                <v-row justify="space-between">
                  <span class="text-h6 font-weight-light title-lbl"
                    >Additional Info</span
                  >
                  <v-col cols="12" lg="6" xs="12">
                    <div class="menu-sec">
                      <v-list-item
                        class="v-flex justify-content-between align-items-center"
                      >
                        <label class="labelFontsize">Contract Number</label>
                        <label>{{ item.deal_no }}</label>
                      </v-list-item>
                      <v-list-item
                        class="v-flex justify-content-between align-items-center"
                      >
                        <label class="labelFontsize">Source of Fund</label>
                        <label>{{ item.source_of_funds }}</label>
                      </v-list-item>

                      <v-list-item
                        class="v-flex justify-content-between align-items-center"
                      >
                        <label>PP CCY</label>
                        <label>{{ item.pp_ccy }}</label>
                      </v-list-item>

                      <v-list-item
                        class="v-flex justify-content-between align-items-center"
                      >
                        <label class="labelFontsize">Purchase Date</label>
                        <label>{{ item.purchase_date }}</label>
                      </v-list-item>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" xs="12">
                    <div class="menu-sec">
                      <v-list-item
                        class="v-flex justify-content-between align-items-center"
                      >
                        <label class="labelFontsize">Dealer</label>
                        <label>{{ item.bank_poc }}</label>
                      </v-list-item>
                      <v-list-item
                        class="v-flex justify-content-between align-items-center"
                      >
                        <label class="labelFontsize">Created by</label>
                        <label>{{ item.created_by }}</label>
                      </v-list-item>
                      <v-list-item
                        class="d-flex justify-content-between align-items-center"
                      >
                        <label class="labelFontsize">Edited by</label>
                        <label>{{ item.edited_by }}</label>
                      </v-list-item>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="3" xs="12">
                <div class="menu-sec">
                  <v-btn depressed 
                    color="primary"
                    variant="outline-light"
                    size="sm"
                    small
                    class="wd-100p mb-2 btn-light"
                    @click="updateDeal(item)"
                  >
                    <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
                    <v-icon small class="me-2"
                      >mdi-content-save-edit-outline</v-icon
                    >
                    Update
                  </v-btn>
                  <v-btn depressed 
                    color="primary"
                    variant="outline-light"
                    size="sm"
                    small
                    class="wd-100p mb-2 btn-light"
                    @click="deleteDeal(item)"
                  >
                    <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                    Delete
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <OverlayPageVue :showOverlay="loaderOverlay" />
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import alerts from "@/mixins/alerts";
import treasuryService from "@/services/TreasuryService/treasuryService.js";

export default {
  name: "Business Deals",
  mixins: [alerts],

  data: () => {
    return {
      loaderOverlay: false,
      expanded: [],
      headers: [
        { text: "", value: "data-table-expand", sortable: false },
        { text: "Business User", value: "remitter" },
        { text: "Booking Date", value: "deal_date" },
        { text: "FCY Rate", value: "usd_amount" },
        { text: "FCY Amount", value: "pp_amount" },
        { text: "Status", value: "status" },
      ],
      userList: [],
      search: "",
    };
  },

  mounted() {
    this.getRemitteList();
  },

  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "Bus_Deals");
      }
    },
    async getRemitteList() {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.getAllBUSdeals();
        console.log(responseData, "response");
        if (responseData && responseData.data.status_code == 200) {
          this.userList = responseData.data.data[0];
          console.log("usrelist", this.userList);
          this.stoploader();
        } else {
          this.loaderOverlay = false;
          this.showAlertError("Failed:" + responseData.data.message);
        }
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },

    newDealClick() {
      this.$router.push({
        name: "New Business Deals",
        // query: { id: item.employee_id },
        // params: {id:item.employee_id}
      });
    },

    updateDeal(item) {
      this.$router.push({
        name: "New Business Deals",
        query: { id: item.deal_id },
        // params: {id:item.employee_id}
      });
    },

    format(date) {
      if (date) {
        date = new Date(date);
        let month = date.toLocaleString("en-US", { month: "short" });
        return date.getDate() + " " + month + " " + date.getFullYear();
      }
    },
    async deleteDeal(selectedRow) {
      try {
        const responseData = await treasuryService.deleteNewContract(
          selectedRow.deal_id
        );
        console.log(responseData, "response");
        if (responseData && responseData.data.status_code == 200) {
          const index = this.userList.findIndex(
            (ele) => ele.deal_id === selectedRow.deal_id
          );
          this.userList.splice(index, 1);
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
      } catch (err) {
        console.log(err);
        this.showAlertError("Failed: Something went wrong");
      }
      // axios({
      //   url: `${process.env.VUE_APP_TREASURY_BASEURL}/api/v1/new-contract/delete-contract/${selectedRow.deal_id}`,
      //   method: "DELETE",
      //   headers: {
      //     Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
      //   },
      // })
      //   .then((response) => {
      //     if (response.status === 200) {
      //       const index = this.userList.findIndex(
      //         (ele) => ele.deal_id === selectedRow.deal_id
      //       );
      //       this.userList.splice(index, 1);
      //     }
      //   })
      //   .catch((err) => {
      //     console.log("Deal not posted", err);
      //   });
    },
    newSettlementClicked(selectedRow) {
      // this.$emit('openTab', 'settlements')
      this.$router.push({ name: "Settlements" });
      this.$store.commit("app/set_selected_deal_id", selectedRow.deal_id);
    },
    exportClick() {
      console.log("export btn clicked");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";

.title-lbl {
  width: 100%;
  padding: 5px;
  text-align: center;
  font-weight: bold;
  color: $txt;
  border-bottom: 1px solid $txt;
}

.menu-sec {
  margin-top: 0.5rem;
  .v-list-item {
    min-height: 36px;
    label {
      width: 50%;
    }
  }
}
</style>
